import PropTypes from 'prop-types';
import React from 'react';

const Region = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m2.338 19.107 8.76-5.847a8.726 8.726 0 0 1 9.744.038c.1.068.168.175.187.296l.455 3.005c.153 1.01.23 1.514.122 1.918a2 2 0 0 1-1.131 1.316C20.092 20 19.58 20 18.56 20H2.609a.488.488 0 0 1-.271-.893Z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M21.43 16.069v0a6.927 6.927 0 0 0-8.43-.516l-2 1.352M6.853 11c-1.21 0-1.304-.001-1.35-.003C4.11 10.927 3 9.816 3 8.455c0-1.406 1.183-2.546 2.642-2.546.307 0 .601.05.875.143C6.99 4.852 8.195 4 9.606 4M18.797 12.075a4 4 0 1 0-4.527-.651M13 6l-1.5-1M13 9.5 9 11M21 11l1.5 1M20.5 6 23 4.5M16.78 1.5v3"
    />
  </svg>
);

Region.propTypes = {
  className: PropTypes.string,
};

export default Region;
